import { routePlanApis } from '@apis/dashboard/routePlanApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const useDeleteRoutePlan = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await routePlanApis.delete('/dashboard/route-plan/{id}/', {
        path: {
          id,
        },
      });
      return response[204]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (k) => k.queryKey[0] === '/dashboard/route-plan/',
        });
      },
    },
  );
};
